import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { UserConsumer } from 'client/components/UserContext';

import LoadingIndicator from './LoadingIndicator';

const AdminRoute = (props: RouteProps) => (
  <UserConsumer>
    {({ userId, user, loggingIn, loading }) => {
      if (loggingIn) {
        return <LoadingIndicator />;
      }
      if (!userId) {
        return (
          <Redirect
            to={{
              pathname: '/signin',
              search: new URLSearchParams({ redirect_path: props.location.pathname }).toString(),
            }}
          />
        );
      }
      if (loading || !user) {
        return <LoadingIndicator />;
      }
      if (user.role !== 'admin') {
        return <Redirect to="/" />;
      }
      return <Route {...props} />;
    }}
  </UserConsumer>
);

export default AdminRoute;
